export default {
  data() {
    return {
      show: false,
    }
  },
  methods: {
    open() {
      return new Promise((resolve, reject) => {
        this.show = true;
        this.resetForm();
        resolve();
      })
    },
    close() {
      return new Promise((resolve, reject) => {
        this.show = false;
        resolve();
      })
    },
    resetForm() {
    }
  }
}